module.exports = __webpack_public_path__ + "static/assets/7aeb8b6cb70b17f661e2fa6258d4d99a.png";